<ng-container>
  <div class="editor-modal-grid">
    <div class="editor-col"
         [class.single-column]="!gptResponse()"
         [class.two-columns]="gptResponse()"
    >
      <app-editor
        id="gpt-editor"
        [plugins]="['QundisGPT']"
        [content]="editorData()"
        (newEditorEvent)="onEditorEvent($event)"
        (gptResponse)="onGptResponse($event)"
      >
      </app-editor>
    </div>
    @if (gptResponse() || aiService.isGenerating()) {
      <div class="gpt-col mt-3">
        <div class="gpt-card">
          @if (aiService.isGenerating()) {
            <div class="d-flex flex-row align-items-center">
              <div class="spinner-border text-primary d-flex justify-content-center"></div>
              <span class="ms-2">Vorschlag wird generiert...</span>
            </div>
          }
          @if (gptResponse()) {
            <div [innerHTML]="gptResponse()"></div>
            <div class="button-section d-flex justify-content-end">
              <button class="btn btn-qundis-primary" (click)="acceptGptSolution()">Antwort übernehmen</button>
            </div>
          }
        </div>
      </div>
    }
  </div>
</ng-container>
